import { Turbo } from "@hotwired/turbo-rails"

Turbo.session.drive = false;
